module.exports = __webpack_public_path__ + "img/question.fd89d42b.png";